//to be used in .tsx files
export const SkanskaColorTokens = {
  color_primary_blue: "rgba(20,50,117,1)",
  color_primary_gray: "rgba(236,236,236,1)",
  color_primary_gray_15: "rgba(236,236,236,0.150)",
  color_secondary_active_green: "rgba(62,206,123,1)",
  color_secondary_white: "rgba(255,255,255,1)",
  color_secondary_white_opacity_15: "rgba(255,255,255,0.850)",
  color_secondary_white_opacity_30: "rgba(255,255,255,0.700)",
  color_secondary_white_opacity_60: "rgba(255,255,255,0.400)",
  color_secondary_white_opacity_80: "rgba(255,255,255,0.200)",
  color_secondary_dim_white: "rgba(245,245,245,1)",
  color_secondary_light_gray: "rgba(236,236,236,1)",
  color_secondary_middle_gray: "rgba(214,214,214,1)",
  color_secondary_dark_gray: "rgba(133,133,133,1)",
  color_secondary_dim_black: "rgba(51,51,51,1)",
  color_secondary_black: "rgba(0,0,0,1)",
  color_tertiary_red: "rgba(175,49,73,1)",
  color_tertiary_red_80: "rgba(191,90,109,1)",
  color_tertiary_red_60: "rgba(207,131,146,1)",
  color_tertiary_red_30: "rgba(231,193,200,1)",
  color_tertiary_red_15: "rgba(243,224,228,1)",
  color_tertiary_teal: "rgba(75,159,163,1)",
  color_tertiary_teal_80: "rgba(111,178,181,1)",
  color_tertiary_teal_60: "rgba(147,197,200,1)",
  color_tertiary_teal_30: "rgba(201,226,227,1)",
  color_tertiary_teal_15: "rgba(228,241,241,1)",
  color_tertiary_orange: "rgba(237,169,119,1)",
  color_tertiary_orange_80: "rgba(241,186,146,1)",
  color_tertiary_orange_60: "rgba(244,203,173,1)",
  color_tertiary_orange_30: "rgba(250,229,214,1)",
  color_tertiary_orange_15: "rgba(252,242,235,1)",
  color_tertiary_green: "rgba(174,221,188,1)",
  color_tertiary_green_80: "rgba(190,228,201,1)",
  color_tertiary_green_60: "rgba(206,235,215,1)",
  color_tertiary_green_30: "rgba(231,245,235,1)",
  color_tertiary_green_15: "rgba(243,250,245,1)",
  color_tertiary_yellow: "rgba(244,221,125,1)",
  color_tertiary_yellow_80: "rgba(246,228,151,1)",
  color_tertiary_yellow_60: "rgba(248,235,177,1)",
  color_tertiary_yellow_30: "rgba(252,245,216,1)",
  color_tertiary_yellow_15: "rgba(253,250,236,1)",
  color_tertiary_paleblue: "rgba(60,88,158,1)",
  color_tertiary_paleblue_80: "rgba(99,121,177,1)",
  color_tertiary_paleblue_60: "rgba(138,155,197,1)",
  color_tertiary_paleblue_30: "rgba(196,205,226,1)",
  color_tertiary_paleblue_15: "rgba(226,230,240,1)",
  color_tertiary_beige: "rgba(221,214,192,1)",
  color_tertiary_beige_80: "rgba(228,222,205,1)",
  color_tertiary_beige_60: "rgba(235,230,217,1)",
  color_tertiary_beige_30: "rgba(245,243,236,1)",
  color_tertiary_beige_15: "rgba(250,249,246,1)",
  color_tertiary_purple: "rgba(130,74,142,1)",
  color_tertiary_purple_80: "rgba(155,110,165,1)",
  color_tertiary_purple_60: "rgba(180,146,187,1)",
  color_tertiary_purple_30: "rgba(217,201,221,1)",
  color_tertiary_purple_15: "rgba(236,228,238,1)",
  color_action_red: "rgba(238,47,83,1)",
  color_action_orange: "rgba(245,135,19,1)",
  color_action_yellow: "rgba(251,237,84,1)",
  color_action_green: "rgba(62,206,123,1)",
  color_action_blue: "rgba(35,86,229,1)",
  color_transparent: "transparent",
  transition_bezier_curve_veryfast: ".1s cubic_bezier(0.25, 0.1, 0.25, 1)",
  transition_bezier_curve_fast: ".25s cubic_bezier(0.25, 0.1, 0.25, 1)",
  transition_bezier_curve_medium: ".4s cubic_bezier(0.25, 0.1, 0.25, 1)",
  transition_bezier_curve_slow: ".65s cubic_bezier(0.25, 0.1, 0.25, 1)",
};
